<template>
  <div class="mx-auto max-w-7xl pt-4 pb-24 overflow-hidden lg:relative">
    <div>
      <div class="px-4 max-w-xl mx-auto">
        <slot name="header"></slot>
      </div>
      <!-- Progress stepper moved below header -->
      <nav class="max-w-xl mx-auto mt-2 md:mt-8 px-4" aria-label="Progress">
        <ol role="list" class="border border-gray-300 rounded-md divide-y divide-gray-300 md:flex md:divide-y-0">
          <li class="relative md:flex-1 md:flex">
            <!-- Current Step -->
            <div class="px-4 py-2 flex items-center text-xs font-medium" aria-current="step">
                  <span
                    class="flex-shrink-0 w-4 h-4 flex items-center justify-center border-2 border-wiq-green rounded-full">
                    <span class="text-wiq-green">1</span>
                  </span>
              <span class="ml-2 text-xs font-medium text-wiq-green">Activate</span>
            </div>
            <!-- Arrow separator for lg screens and up -->
            <div class="hidden md:block absolute top-0 right-0 h-full w-2" aria-hidden="true">
              <svg class="h-full w-full text-gray-300" viewBox="0 0 22 80" fill="none" preserveAspectRatio="none">
                <path d="M0 -2L20 40L0 82" vector-effect="non-scaling-stroke" stroke="currentcolor"
                      stroke-linejoin="round"/>
              </svg>
            </div>
          </li>
          <li class="relative md:flex-1 md:flex">
            <!-- Upcoming Step -->
            <div class="group flex items-center">
        <span class="px-4 py-2 flex items-center text-xs font-medium">
          <span
            class="flex-shrink-0 w-4 h-4 flex items-center justify-center border-2 border-gray-300 rounded-full group-hover:border-gray-400">
            <span class="text-gray-500 group-hover:text-gray-900">2</span>
          </span>
          <span class="ml-2 text-xs font-medium text-gray-500">Configure</span>
        </span>
            </div>
            <div class="hidden md:block absolute top-0 right-0 h-full w-2" aria-hidden="true">
              <svg class="h-full w-full text-gray-300" viewBox="0 0 22 80" fill="none" preserveAspectRatio="none">
                <path d="M0 -2L20 40L0 82" vector-effect="non-scaling-stroke" stroke="currentcolor"
                      stroke-linejoin="round"/>
              </svg>
            </div>
          </li>
          <li class="relative md:flex-1 md:flex">
            <!-- Upcoming Step -->
            <div class="group flex items-center">
        <span class="px-4 py-2 flex items-center text-xs font-medium">
          <span
            class="flex-shrink-0 w-4 h-4 flex items-center justify-center border-2 border-gray-300 rounded-full group-hover:border-gray-400">
            <span class="text-gray-500 group-hover:text-gray-900">3</span>
          </span>
          <span class="ml-2 text-xs font-medium text-gray-500">Go live</span>
        </span>
            </div>
          </li>
        </ol>
      </nav>
      <div class="mt-9 md:mt-20">
        <div v-if="isWlag">
          <div class="inline-flex space-x-4">
                <span class="rounded bg-pink-500 px-2.5 py-1 text-xs font-semibold text-white tracking-wide uppercase">
                  10% of sales go to Wrestle Like A Girl
                </span>
          </div>
        </div>
        <div class="mt-6 px-4 mx-auto sm:max-w-xl">
          <h1 class="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
            Create your team's WrestlingIQ account
          </h1>
          <div class="relative mt-6" v-if="showActivationForm">
            <p class="text-xl text-gray-500">
              You won't pay a dime until your season starts or you collect your first payment.<br><br>
            </p>
          </div>
        </div>
        <div class="px-4 mx-auto sm:max-w-xl mt-12" v-if="showParentBlockerChoices">
          <h2 class="text-base font-semibold uppercase text-gray-700 tracking-wider">
            What is your role on the team?
          </h2>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-3 mt-4">
            <div @click.prevent="enbaleActivateForm" class="bg-gray-50 border shadow-xs border-gray-200 rounded-sm cursor-pointer p-8 flex items-center justify-center">
              <h3 class="text-lg">I am a <span class="font-bold">coach</span> or <span class="font-bold">team admin</span></h3>
            </div>
            <div @click.prevent="enableParentBlocker" class="bg-gray-50 border shadow-xs border-gray-200 rounded-sm cursor-pointer p-8 flex items-center justify-center">
              <h3 class="text-lg">I am a <span class="font-bold">parent</span> or <span class="font-bold">wrestler</span></h3>
            </div>
          </div>
        </div>
        <div class="sm:max-w-xl mx-auto mt-12" v-if="showParentBlocker">
          <div class="rounded-md bg-yellow-50 p-4 sm:max-w-xl">
            <div class="flex">
              <div class="flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-yellow-400 mt-1">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                </svg>
              </div>
              <div class="ml-3">
                <h3 class="text-lg font-extrabold text-yellow-900">
                  This page is only for coaches and team admins
                </h3>
                <p class="text-base mt-6">
                  <span class="font-semibold">If you do not have a login</span>, please contact your coach for an <span class="font-semibold">invite</span> or <span class="font-semibold">team registration url</span> to join your team's WrestlingIQ account.
                </p>
                <p class="text-base mt-4">
                  <span class="font-semibold">If you already have a WrestlingIQ login</span>, sign in or reset your password.
                </p>
                <ul class="text-base mt-2">
                  <li><a href="/users/sign_in" class="underline">Sign in</a></li>
                  <li><a href="/users/password/new" class="underline">Reset your password</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <ValidationObserver ref="observer" v-slot="{ handleSubmit, failed } ">
        <div class="grid grid-cols-1 md:max-w-xl mx-auto">
          <div v-show="showActivationForm" class="relative px-4">
            <section aria-labelledby="summary-heading" class="bg-gray-50 border border-gray-200 shadow-sm rounded-lg px-4 py-6 sm:p-6 lg:p-8">
              <h2 id="summary-heading" class="text-lg font-medium text-gray-900">This WrestlingIQ account is for..</h2>
              <div class="mt-4">
                <label for="teamLevel" class="text-sm font-medium text-gray-700 hidden">Account type</label>
                <select id="teamLevel" v-model="teamLevel" name="team level"
                        class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-wiq-green focus:border-wiq-green sm:text-sm">
                  <option v-for="l in availableLevels" :value="l">{{ l }}</option>
                </select>
              </div>
              <div v-if="isBooster">
                <!-- Make sure you are a booster section -->
                <div class="bg-red-50 border border-red-200 rounded-lg p-4 my-4">
                  <div class="bg-red-800 text-white p-4 -m-4 rounded-t-lg">
                    <span class="text-sm font-bold tracking-widest uppercase">Do you run wrestling camps, clinics, or a youth program through the booster club?</span>
                  </div>
                  <p class="text-base text-red-900 mt-8">
                    <span class="font-bold">If yes:</span> Select 'Club' as the account type above. You'll have access to all fundraising features plus wrestling-specific registration options.
                  </p>
                  <p class="text-base text-red-900 mt-4">
                    <span class="font-bold">If no:</span> Continue with 'Booster club' for fundraising, donations, and online store functionality only.
                  </p>
                </div>
              </div>
              <div v-if="isRec">
                <!-- Make sure you are a town rec program section -->
                <div class="bg-red-50 border border-red-200 rounded-lg p-4 my-4">
                  <div class="bg-red-800 text-white p-4 -m-4 rounded-t-lg">
                    <span class="text-sm font-bold tracking-widest uppercase">Does your town process payments on behalf of your team?</span>
                  </div>
                  <p class="text-base text-red-900 mt-8">
                    <span class="font-bold">If yes:</span> Continue with 'Town Rec Program'. We expect the town to handle all payments and to send you a spreadsheet of participants to import into WrestlingIQ.
                  </p>
                  <p class="text-base text-red-900 mt-4">
                    <span class="font-bold">If no:</span> Select 'Club' as the account type above if you collect payments directly from parents—you will get WrestlingIQ's full online registraion features.
                  </p>
                </div>
              </div>
              <p v-if="hasSelectedTeamLevel" class="text-sm uppercase font-semibold tracking-widest mt-8 text-gray-700">pricing</p>
              <div v-if="isClub || isRTC" class="mt-4">
                <!-- How it works section -->
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
                  <div class="bg-blue-50 border-2 border-blue-200 rounded-lg overflow-hidden">
                    <div class="bg-blue-600 text-blue-50 text-center py-1.5">
                      <span class="text-sm font-bold tracking-widest uppercase">Club pays</span>
                    </div>
                    <div class="p-4">
                      <p class="text-sm font-semibold text-gray-700 mb-2">Card Processing</p>
                      <p class="text-3xl font-bold text-gray-900">2.9% + 30¢</p>
                      <p class="text-sm text-gray-600 mt-2">Per successful transaction</p>
                    </div>
                  </div>
                  <div class="bg-purple-50 border-2 border-purple-200 rounded-lg overflow-hidden">
                    <div class="bg-purple-600 text-purple-50 text-center py-1.5">
                      <span class="text-sm font-bold tracking-widest uppercase">Parent pays</span>
                    </div>
                    <div class="p-4">
                      <p class="text-sm font-semibold text-gray-700 mb-2">WrestlingIQ Fee</p>
                      <p class="text-3xl font-bold text-gray-900">2%</p>
                      <p class="text-sm text-gray-600 mt-2">Added to each transaction</p>
                    </div>
                  </div>
                </div>

                <!-- Visual breakdown box -->
                <div class="bg-gray-50 border border-gray-200 rounded-lg p-4">
                  <p class="text-sm font-semibold text-gray-700 mb-3">Example: $100 camp registration</p>
                  <div class="space-y-2">
                    <div class="flex justify-between items-center">
                      <span class="text-sm text-gray-600">You set registration price:</span>
                      <span class="text-sm font-medium">$100.00</span>
                    </div>
                    <div class="flex justify-between items-center">
                      <span class="text-sm text-gray-600">WIQ service fee is added:</span>
                      <div class="text-right flex items-center gap-x-2">
                        <div class="text-xs text-purple-600 border border-purple-200 bg-purple-50 px-2 py-0.5 rounded-xl inline-block">+2%</div>
                        <span class="text-sm font-medium text-purple-600">$2.00</span>
                      </div>
                    </div>
                    <div class="flex justify-between items-center">
                      <span class="text-sm text-gray-600">Parent pays:</span>
                      <span class="text-sm font-medium">$102.00</span>
                    </div>
                    <div class="border-t border-gray-300 my-2"></div>
                    <div class="flex justify-between items-center">
                      <span class="text-sm text-gray-600">Total for club:</span>
                      <span class="text-sm font-medium text-green-600">$100.00</span>
                    </div>
                    <div class="flex justify-between items-center">
                      <span class="text-sm text-gray-600">Card processing:</span>
                      <div class="text-right flex items-center gap-x-2">
                        <div class="text-xs text-blue-600 border border-blue-200 bg-blue-50 px-2 py-0.5 rounded-xl inline-block">2.9% + $0.30</div>
                        <span class="text-sm font-medium text-blue-600">-$3.26</span>
                      </div>
                    </div>
                    <div class="border-t border-gray-300 my-2"></div>
                    <div class="flex justify-between items-center">
                      <span class="text-sm font-semibold text-gray-700">Club receives:</span>
                      <span class="text-sm font-bold text-gray-900">$96.74</span>
                    </div>
                  </div>
                  <p class="text-xs text-gray-500 mt-3 text-center">
                    💡 No fees between transactions!
                  </p>
                </div>

                <!-- Gray divider -->
                <div class="border-t border-gray-300 my-12"></div>

                <!-- No monthly fees section -->
                <div class="bg-green-50 border border-green-200 rounded-lg p-4 my-4">
                  <div class="bg-wiq-green text-white text-center py-1.5 -m-4 rounded-t-lg">
                    <span class="text-sm font-bold tracking-widest uppercase">With WrestlingIQ You Have</span>
                  </div>
                  <div class="flex items-start space-x-3 mt-8">
                    <svg class="flex-shrink-0 h-5 w-5 text-green-600 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div>
                      <p class="text-lg font-semibold text-green-900">$0 monthly fees</p>
                      <p class="text-sm text-green-700">No subscription required</p>
                    </div>
                  </div>
                  <div class="flex items-start space-x-3 mt-3">
                    <svg class="flex-shrink-0 h-5 w-5 text-green-600 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div>
                      <p class="text-lg font-semibold text-green-900">$0 annual fees</p>
                      <p class="text-sm text-green-700">No annual cost</p>
                    </div>
                  </div>
                  <div class="flex items-start space-x-3 mt-3">
                    <svg class="flex-shrink-0 h-5 w-5 text-green-600 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div>
                      <p class="text-lg font-semibold text-green-900">Free setup assistance</p>
                      <p class="text-sm text-green-700">Optional - book a call with our expert team to get your account set up</p>
                    </div>
                  </div>
                  <div class="flex items-start space-x-3 mt-3">
                    <svg class="flex-shrink-0 h-5 w-5 text-green-600 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div>
                      <p class="text-lg font-semibold text-green-900">Website services add-on available</p>
                      <p class="text-sm text-green-700">Optional - we offer full website services</p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isBooster" class="mt-4">
                <!-- How it works section -->
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
                  <div class="bg-blue-50 border-2 border-blue-200 rounded-lg overflow-hidden">
                    <div class="bg-blue-600 text-blue-50 text-center py-1.5">
                      <span class="text-sm font-bold tracking-widest uppercase">Booster club pays</span>
                    </div>
                    <div class="p-4">
                      <p class="text-sm font-semibold text-gray-700 mb-2">Card Processing</p>
                      <p class="text-3xl font-bold text-gray-900">2.9% + 30¢</p>
                      <p class="text-sm text-gray-600 mt-2">Per successful transaction</p>
                    </div>
                  </div>
                  <div class="bg-purple-50 border-2 border-purple-200 rounded-lg overflow-hidden">
                    <div class="bg-purple-600 text-purple-50 text-center py-1.5">
                      <span class="text-sm font-bold tracking-widest uppercase">Parent pays</span>
                    </div>
                    <div class="p-4">
                      <p class="text-sm font-semibold text-gray-700 mb-2">WrestlingIQ Fee</p>
                      <p class="text-3xl font-bold text-gray-900">2%</p>
                      <p class="text-sm text-gray-600 mt-2">Added to each transaction</p>
                    </div>
                  </div>
                </div>

                <!-- Visual breakdown box -->
                <div class="bg-gray-50 border border-gray-200 rounded-lg p-4">
                  <p class="text-sm font-semibold text-gray-700 mb-3">Example: $100 fundraiser donation</p>
                  <div class="space-y-2">
                    <div class="flex justify-between items-center">
                      <span class="text-sm text-gray-600">You set fundraiser tier:</span>
                      <span class="text-sm font-medium">$100.00</span>
                    </div>
                    <div class="flex justify-between items-center">
                      <span class="text-sm text-gray-600">WIQ service fee is added:</span>
                      <div class="text-right flex items-center gap-x-2">
                        <div class="text-xs text-purple-600 border border-purple-200 bg-purple-50 px-2 py-0.5 rounded-xl inline-block">+2%</div>
                        <span class="text-sm font-medium text-purple-600">$2.00</span>
                      </div>
                    </div>
                    <div class="flex justify-between items-center">
                      <span class="text-sm text-gray-600">Parent pays:</span>
                      <span class="text-sm font-medium">$102.00</span>
                    </div>
                    <div class="border-t border-gray-300 my-2"></div>
                    <div class="flex justify-between items-center">
                      <span class="text-sm text-gray-600">Total for booster club:</span>
                      <span class="text-sm font-medium text-green-600">$100.00</span>
                    </div>
                    <div class="flex justify-between items-center">
                      <span class="text-sm text-gray-600">Card processing:</span>
                      <div class="text-right flex items-center gap-x-2">
                        <div class="text-xs text-blue-600 border border-blue-200 bg-blue-50 px-2 py-0.5 rounded-xl inline-block">2.9% + $0.30</div>
                        <span class="text-sm font-medium text-blue-600">-$3.26</span>
                      </div>
                    </div>
                    <div class="border-t border-gray-300 my-2"></div>
                    <div class="flex justify-between items-center">
                      <span class="text-sm font-semibold text-gray-700">Booster club receives:</span>
                      <span class="text-sm font-bold text-gray-900">$96.74</span>
                    </div>
                  </div>
                  <p class="text-xs text-gray-500 mt-3 text-center">
                    💡 No fees between transactions!
                  </p>
                  <p class="text-xs text-gray-500 mt-1 text-center">
                    💡 Most donors opt-in to cover the fees!
                  </p>
                </div>
              </div>
              <div v-if="isHs || isCollege" class="mt-4">
                <p class="text-4xl font-extrabold text-gray-900">
                  {{ hsPrice }}
                </p>
                <p class="text-gray-700 text-baseline mt-2">
                  Invoiced two weeks after your first practice.
                </p>
              </div>
              <div v-if="isJhs || isRec" class="mt-4">
                <p class="text-4xl font-extrabold text-gray-900">
                  $300 /year
                </p>
                <p class="text-gray-700 text-baseline mt-2">
                  Invoiced two weeks after your first practice.
                </p>
              </div>
            </section>
          </div>
          <div class="px-4 sm:px-6 lg:px-8">
            <form v-show="showActivationForm && hasSelectedTeamLevel" class="mt-8 grid grid-cols-1 gap-y-6 md:max-w-xl md:grid-cols-2 md:gap-x-8" @focusin="trackFormStart">
              <div class="md:col-span-2">
                <h2 class="text-lg font-medium text-gray-900">Your contact info</h2>
                <p class="text-sm text-gray-500 mt-1">As the point of contact, you will receive an admin/coach account and
                  will be in charge of investing some time to configure WrestlingIQ.</p>
              </div>
              <ValidationProvider name="first name" rules="required" v-slot="{ errors }">
                <div>
                  <label for="first-name" class="block text-sm font-medium text-gray-700">First name</label>
                  <div class="mt-1 relative rounded-md shadow-sm">
                    <input type="text" name="first-name" id="first-name"
                           autocomplete="given-name"
                           v-model="firstName"
                           :class="inputClasses(errors[0])"
                    >
                    <error-icon v-if="errors[0]"></error-icon>
                  </div>
                  <p class="mt-2 text-sm text-red-600" v-if="errors[0]">
                    {{ errors[0] }}
                  </p>
                </div>
              </ValidationProvider>
              <ValidationProvider name="last name" rules="required" v-slot="{ errors }">
                <div>
                  <label for="last-name" class="block text-sm font-medium text-gray-700">Last name</label>
                  <div class="mt-1 relative rounded-md shadow-sm">
                    <input type="text" name="last-name" id="last-name"
                           autocomplete="family-name"
                           v-model="lastName"
                           :class="inputClasses(errors[0])"
                    >
                    <error-icon v-if="errors[0]"></error-icon>
                  </div>
                  <p class="mt-2 text-sm text-red-600" v-if="errors[0]">
                    {{ errors[0] }}
                  </p>
                </div>
              </ValidationProvider>
              <div class="md:col-span-2">
                <ValidationProvider name="email" rules="required|email" :debounce="500" v-slot="{ errors }">
                  <div>
                    <label for="email" class="block text-sm font-medium text-gray-700">Email</label>
                    <div class="mt-1 relative rounded-md shadow-sm">
                      <input type="text"
                             autocomplete="email"
                             name="email"
                             id="email"
                             v-model="email"
                             :class="inputClasses(errors[0])"
                      >
                      <error-icon v-if="errors[0]"></error-icon>
                    </div>
                    <p class="mt-2 text-sm text-red-600" v-if="errors[0]">
                      {{ errors[0] }}
                    </p>
                  </div>
                </ValidationProvider>
              </div>
              <div class="md:col-span-2">
                <ValidationProvider name="phone" rules="required|digits:10" v-slot="{ errors }">
                  <div>
                    <label for="phone" class="block text-sm font-medium text-gray-700">Phone</label>
                    <div class="mt-1 relative rounded-md shadow-sm">
                      <the-mask mask="(###) ### - ####"
                                v-model="phone"
                                :class="inputClasses(errors[0])"
                                id="phone"
                                ref="phone"
                                type="tel">
                      </the-mask>
                      <error-icon v-if="errors[0]"></error-icon>
                    </div>
                    <p class="mt-2 text-sm text-red-600" v-if="errors[0]">
                      {{ errors[0] }}
                    </p>
                  </div>
                </ValidationProvider>
              </div>
              <div class="md:col-span-2 mt-6">
                <h2 class="text-lg font-medium text-gray-900">Additional admins (optional)</h2>
                <p class="text-sm text-gray-500 mt-1">
                  Are there any additional coaches or admins who will be assisting you with setting up the team account? You can always invite additional admins later. Assistant coaches will be invited after your account is setup.
                </p>
                <div class="mt-4">
                  <div v-for="(admin, index) in additionalAdmins" :key="index" class="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4">
                    <div class="flex justify-between items-start mb-3">
                      <h3 class="text-sm font-medium text-gray-900">Additional admin</h3>
                      <button @click="removeAdmin(index)" type="button" class="text-red-600 hover:text-red-800 text-sm">
                        Remove
                      </button>
                    </div>
                    <div class="grid grid-cols-1 mt-2 md:grid-cols-2 gap-4">
                      <ValidationProvider :name="`admin ${index + 1} first name`" rules="required" v-slot="{ errors }">
                        <div>
                          <label :for="`admin-first-name-${index}`" class="block text-sm font-medium text-gray-700">First name</label>
                          <div class="mt-1 relative rounded-md shadow-sm">
                            <input
                              type="text"
                              :id="`admin-first-name-${index}`"
                              v-model="admin.first_name"
                              autocomplete="given-name"
                              :class="inputClasses(errors[0])"
                            >
                            <error-icon v-if="errors[0]"></error-icon>
                          </div>
                          <p class="mt-2 text-sm text-red-600" v-if="errors[0]">
                            {{ errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                      <ValidationProvider :name="`admin ${index + 1} last name`" rules="required" v-slot="{ errors }">
                        <div>
                          <label :for="`admin-last-name-${index}`" class="block text-sm font-medium text-gray-700">Last name</label>
                          <div class="mt-1 relative rounded-md shadow-sm">
                            <input
                              type="text"
                              :id="`admin-last-name-${index}`"
                              v-model="admin.last_name"
                              autocomplete="family-name"
                              :class="inputClasses(errors[0])"
                            >
                            <error-icon v-if="errors[0]"></error-icon>
                          </div>
                          <p class="mt-2 text-sm text-red-600" v-if="errors[0]">
                            {{ errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                      <div class="md:col-span-2">
                        <ValidationProvider :name="`admin ${index + 1} email`" rules="required|email" v-slot="{ errors }">
                          <div>
                            <label :for="`admin-email-${index}`" class="block text-sm font-medium text-gray-700">Email</label>
                            <div class="mt-1 relative rounded-md shadow-sm">
                              <input
                                type="email"
                                :id="`admin-email-${index}`"
                                v-model="admin.email"
                                autocomplete="email"
                                :class="inputClasses(errors[0])"
                              >
                              <error-icon v-if="errors[0]"></error-icon>
                            </div>
                            <p class="mt-2 text-sm text-red-600" v-if="errors[0]">
                              {{ errors[0] }}
                            </p>
                          </div>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                  <button @click="addAdmin" type="button" class="inline-flex items-center px-4 py-2 border border-gray-700 text-sm font-medium rounded-md text-gray-700 bg-gray-50 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-wiq-green">
                    <svg class="-ml-1 mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                    Add admin
                  </button>
                </div>
              </div>
              <div class="md:col-span-2 mt-6">
                <h2 class="text-lg font-medium text-gray-900">Team info</h2>
                <p class="text-sm text-gray-500 mt-1">
                  Enter the team name as you want it to appear to your wrestlers/parents during registration and usage.
                </p>
              </div>
              <div class="md:col-span-2">
                <ValidationProvider name="team name" rules="required" v-slot="{ errors }">
                  <div>
                    <label for="first-name" class="block text-sm font-medium text-gray-700">Team name</label>
                    <div class="mt-1 relative rounded-md shadow-sm">
                      <input type="text" name="team-name" id="team-name"
                             v-model="teamName"
                             autocomplete="organization"
                             :class="inputClasses(errors[0])"
                      >
                      <error-icon v-if="errors[0]"></error-icon>
                    </div>
                    <p class="mt-2 text-sm text-red-600" v-if="errors[0]">
                      {{ errors[0] }}
                    </p>
                  </div>
                </ValidationProvider>
              </div>
              <div class="md:col-span-2">
                <label for="website" class="block text-sm font-medium text-gray-700">
                  Website <span class="text-gray-500 font-normal">(optional)</span>
                </label>
                <p class="text-sm text-gray-500 mt-1">
                  No website? No problem. Share a link to a social media page
                  (Facebook, Instagram, etc.) or anywhere else we can learn more
                  about your team.
                </p>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <input type="text"
                         name="website"
                         id="website"
                         v-model="website"
                         autocomplete="url"
                         placeholder="https://example.com or facebook.com/yourteam"
                         :class="inputClasses()"
                  >
                </div>
              </div>
              <div class="md:col-span-2">
                <ValidationProvider name="country" rules="required" v-slot="{ errors }">
                  <div>
                    <label for="country" class="block text-sm font-medium text-gray-700">Country</label>
                    <div class="mt-1">
                      <select id="country" v-model="country" name="country"
                              :class="inputClasses(errors[0])">
                        <option value="">Select a country</option>
                        <option value="US">United States</option>
                        <option value="AU">Australia</option>
                        <option value="CA">Canada</option>
                        <option value="NZ">New Zealand</option>
                        <option value="GB">United Kingdom</option>
                        <option value="XX">Other</option>
                      </select>
                    </div>
                    <p class="mt-2 text-sm text-red-600" v-if="errors[0]">
                      {{ errors[0] }}
                    </p>
                  </div>
                </ValidationProvider>
              </div>
              <div class="md:col-span-2">
                <ValidationProvider name="state" rules="required" v-slot="{ errors }">
                  <div>
                    <label for="state" class="block text-sm font-medium text-gray-700">{{ stateLabel }}</label>
                    <div class="mt-1">
                      <select v-if="country === 'US'"
                              id="state"
                              v-model="state"
                              name="state"
                              autocomplete="address-level1"
                              :class="inputClasses(errors[0])">
                        <option value="">Select a state</option>
                        <option v-for="usState in usStates" :key="usState.abbr" :value="usState.abbr">
                          {{ usState.name }}
                        </option>
                      </select>
                      <div v-else class="relative rounded-md shadow-sm">
                        <input type="text" name="state" id="state"
                               v-model="state"
                               autocomplete="address-level1"
                               :class="inputClasses(errors[0])"
                        >
                        <error-icon v-if="errors[0]"></error-icon>
                      </div>
                    </div>
                    <p class="mt-2 text-sm text-red-600" v-if="errors[0]">
                      {{ errors[0] }}
                    </p>
                  </div>
                </ValidationProvider>
              </div>
              <div class="md:col-span-2">
                <ValidationProvider name="time zone" rules="required" v-slot="{ errors }">
                  <div>
                    <label for="tz" class="block text-sm font-medium text-gray-700">Time zone</label>
                    <div class="mt-1">
                      <select id="tz" v-model="timeZone" name="time zone"
                              class="block w-full bg-white border border-gray-300 rounded-md shadow-sm py-3 px-4 focus:outline-none focus:ring-wiq-green focus:border-wiq-green">
                        <option v-for="tz in timeZones" :value="tz[0]">{{ tz[1] }}</option>
                      </select>
                    </div>
                    <p class="mt-2 text-sm text-red-600" v-if="errors[0]">
                      {{ errors[0] }}
                    </p>
                  </div>
                </ValidationProvider>
              </div>
              <div v-if="isClub" class="md:col-span-2">
                <label for="clubEntityType" class="block text-sm font-medium text-gray-700 mb-2">
                  What type of legal entity is your club?
                </label>
                <div class="relative" @keydown.esc="clubEntityDropdownOpen = false">
                  <button
                    type="button"
                    id="clubEntityType"
                    class="w-full border border-gray-300 rounded-md px-4 py-3 text-left bg-white flex items-center justify-between focus:outline-none focus:ring-wiq-green focus:ring-inset focus:border-wiq-green"
                    @click="clubEntityDropdownOpen = !clubEntityDropdownOpen"
                    :aria-expanded="clubEntityDropdownOpen"
                  >
                  <span v-if="selectedClubEntityType">
                    <span class="text-gray-700">{{ selectedClubEntityType.label }}</span>
                    <span class="block text-xs text-gray-500">{{ selectedClubEntityType.subtext }}</span>
                  </span>
                    <span v-else class="text-gray-400">Select entity type</span>
                    <svg class="w-4 h-4 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                      <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                    </svg>
                  </button>
                  <ul
                    v-show="clubEntityDropdownOpen"
                    class="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg"
                    role="listbox"
                  >
                    <li
                      v-for="type in clubEntityTypes"
                      :key="type.label"
                      @click="selectClubEntityType(type)"
                      class="cursor-pointer p-4 hover:bg-gray-100"
                      :class="{ 'bg-gray-100': type.label === clubEntityType }"
                      role="option"
                      :aria-selected="type.label === clubEntityType"
                    >
                      <div class="text-gray-700">{{ type.label }}</div>
                      <div class="text-xs text-gray-500">{{ type.subtext }}</div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="md:col-span-2 mt-6">
                <h2 class="text-lg font-medium text-gray-900">Goals</h2>
                <p class="text-sm text-gray-500 mt-1">
                  Help us understand what you want to accomplish with WrestlingIQ so we can help you get there.
                </p>
              </div>
              <div class="md:col-span-2">
                <ValidationProvider
                  name="start date"
                  :rules="{ required: true, dateRange: { min: minStartDate, max: maxStartDate } }"
                  v-slot="{ errors }"
                >
                  <div>
                    <label for="startdate" class="block text-sm font-medium text-gray-700">
                      <template v-if="isHsCollegeOrJhs">
                        Day of first practice
                      </template>
                      <template v-else-if="isRTC">
                        Goal date to switch systems?
                      </template>
                      <template v-else>
                        Goal date to accept your first payment/registration through WrestlingIQ
                      </template>
                    </label>
                    <div class="mt-1 relative rounded-md shadow-sm">
                      <input
                        type="date"
                        id="startDate"
                        name="startDate"
                        v-model="startDate"
                        @input="$refs.observer.validate()"
                        :min="minStartDate"
                        :max="maxStartDate"
                        :class="inputClasses(errors[0])"
                      />
                      <error-icon position-classes="absolute inset-y-0 right-6 pr-6" v-if="errors[0]"></error-icon>
                    </div>
                    <p class="mt-2 text-sm text-red-600" v-if="errors[0]">
                      {{ errors[0] }}
                    </p>
                  </div>
                </ValidationProvider>
              </div>
              <div class="md:col-span-2">
                <ValidationProvider name="success-outcome" rules="required" v-slot="{ errors }">
                  <div>
                    <label for="success-outcome" class="block text-sm font-medium text-gray-700">
                      In 3 months, what specific outcome would make you think 'WrestlingIQ was worth it'?
                    </label>
                    <div class="mt-1">
                      <select
                        id="success-outcome"
                        name="success-outcome"
                        v-model="selectedOutcome"
                        :class="inputClasses(errors[0])"
                        class="block w-full bg-white border border-gray-300 rounded-md shadow-sm py-3 px-4 focus:outline-none focus:ring-wiq-green focus:border-wiq-green sm:text-sm"
                      >
                        <option value="">Select an outcome...</option>
                        <option v-for="option in outcomeOptions" :key="option.value" :value="option.value">
                          {{ option.label }}
                        </option>
                        <option value="other">Other</option>
                      </select>
                      <error-icon v-if="errors[0]"></error-icon>
                    </div>
                    <div v-if="selectedOutcome === 'other'" class="mt-3 relative rounded-md shadow-sm">
                      <input
                        type="text"
                        name="success-outcome-other"
                        id="success-outcome-other"
                        placeholder="Please specify..."
                        v-model="customOutcome"
                        class="py-3 px-4 shadow-sm block w-full border-gray-300 rounded-md sm:text-sm focus:ring-wiq-green focus:border-wiq-green"
                      >
                    </div>
                    <p class="mt-2 text-sm text-red-600" v-if="errors[0]">
                      {{ errors[0] }}
                    </p>
                  </div>
                </ValidationProvider>
              </div>
              <div class="md:col-span-2">
                <ValidationProvider name="success-outcome" rules="required" v-slot="{ errors }">
                  <div>
                    <label for="admin-hours" class="block text-sm font-medium text-gray-700">
                      How many hours per week do you spend on administrative tasks?
                    </label>
                    <div class="mt-1 relative rounded-md shadow-sm">
                      <input type="number" name="admin-hours" id="admin-hours"
                             v-model="adminHours"
                             :class="inputClasses(errors[0])"
                      >
                      <error-icon v-if="errors[0]"></error-icon>
                    </div>
                    <p class="mt-2 text-sm text-red-600" v-if="errors[0]">
                      {{ errors[0] }}
                    </p>
                  </div>
                </ValidationProvider>
              </div>
              <div class="md:col-span-2">
                <div>
                  <label class="block text-sm font-medium text-gray-700">
                    Current Pain Points
                  </label>
                  <p class="text-sm text-gray-500 mt-1">
                    Select your top 3 pain points that you'd like to solve with WrestlingIQ.
                  </p>
                  <p class="text-sm mt-2" :class="selectedPainPoints.length === 3 ? 'text-green-600' : 'text-gray-700'">
                    {{ selectedPainPoints.length }} of 3 selected
                  </p>
                  <div class="mt-3 space-y-2">
                    <div
                      v-for="point in painPoints"
                      :key="point.id"
                      class="relative flex items-start p-3 bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow"
                      :class="{ 'border-wiq-green bg-green-50': point.selected }"
                    >
                      <div class="flex items-center h-5">
                        <input
                          :id="`pain-point-${point.id}`"
                          type="checkbox"
                          v-model="point.selected"
                          @change="handlePainPointSelection(point)"
                          :disabled="!point.selected && selectedPainPoints.length >= 3"
                          class="h-4 w-4 text-wiq-green border-gray-300 rounded focus:ring-wiq-green disabled:opacity-50 disabled:cursor-not-allowed"
                        />
                      </div>
                      <div class="ml-3 text-sm">
                        <label :for="`pain-point-${point.id}`" class="text-gray-700 cursor-pointer">
                          {{ point.text }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <p v-if="selectedPainPoints.length < 3" class="mt-2 text-sm text-gray-500">
                    You can select {{ 3 - selectedPainPoints.length }} more pain {{ 3 - selectedPainPoints.length === 1 ? 'point' : 'points' }}.
                  </p>
                </div>
              </div>
              <div class="md:col-span-2">
                <h2 class="text-lg font-medium text-gray-900">Additional information</h2>
                <p class="text-sm text-gray-500 mt-1">
                  Final questions to help us get your team set up for success.
                </p>
              </div>
              <div class="md:col-span-2 flex justify-between gap-x-4">
                <p class="block text-sm text-gray-700">
                  Do you want info about WrestlingIQ website services?<br/>
                  <span class="text-gray-500">
              Websites are an optional paid add-on. You can always request this info later.
            </span>
                </p>
                <button @click="websiteInfo = !websiteInfo" type="button"
                        :class="websiteInfo ? 'bg-wiq-green' : 'bg-gray-200'"
                        class="self-center relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-wiq-green"
                        role="switch"
                        :aria-checked="websiteInfo">
                  <span class="sr-only">Send information about a website hosted through WrestlingIQ?</span>
                  <span aria-hidden="true" :class="websiteInfo ? 'translate-x-5' : 'translate-x-0'"
                        class="pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow ring-0 transition ease-in-out duration-200">
              </span>
                </button>
              </div>
              <div class="md:col-span-2">
                <label for="hearAbout" class="block text-sm font-medium text-gray-700">
                  How did you hear about WrestlingIQ?
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <input type="text"
                         name="hearAbout"
                         id="hearAbout"
                         v-model="hearAbout"
                         :class="inputClasses()"
                  >
                </div>
              </div>
              <div class="md:col-span-2">
                <label for="anythingElse" class="block text-sm font-medium text-gray-700">
                  Anything else we should know to help you be successful with WrestlingIQ?
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
            <textarea name="anythingElse"
                      id="anythingElse"
                      v-model="anythingElse"
                      rows="3"
                      :class="inputClasses()">
            </textarea>
                </div>
              </div>
              <div>
                <button type="submit"
                        @click.prevent="handleSubmit(createLead)"
                        :disabled="creatingLead"
                        class="mt-12 w-full inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-wiq-green hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
                >
                  Create account
                  <spinner v-if="creatingLead" class="ml-2"></spinner>
                </button>
                <p v-if="error" class="text-red-600 mt-2">
                  {{ errorMessage }}
                </p>
                <small v-if="failed" class="text-red-600 mt-2">
                  Please correct one of the errors on the form
                </small>
              </div>
            </form>
            <recaptcha
              ref="recaptcha"
              :captcha-action="captchaAction"
              :captcha-site-key="captchaSiteKey"
              :captcha-v3-site-key="captchaV3SiteKey"
              style="margin-bottom: 16px; margin-top: 16px;"
            ></recaptcha>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { TheMask } from 'vue-the-mask';
import ErrorIcon from './icons/error-icon.vue';
import { recaptchaMix } from '../shared/recaptcha_mix.js';
import Recaptcha from '../shared/recaptcha.vue';
import Spinner from './icons/spinner.vue';

extend('dateRange', {
  params: ['min', 'max'],
  validate(value, { min, max }) {
    if (!value) return true;

    // Strip time components and compare dates only
    const selectedDate = new Date(value).setHours(0, 0, 0, 0);
    const minDate = new Date(min).setHours(0, 0, 0, 0);
    const maxDate = new Date(max).setHours(0, 0, 0, 0);

    return selectedDate >= minDate && selectedDate <= maxDate;
  },
  message(_, { min, max }) {
    const formatDate = (dateStr) => {
      // Create date object and set to midnight UTC to avoid timezone shifts
      const date = new Date(dateStr);
      date.setUTCHours(12, 0, 0, 0);

      return date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC', // Ensure consistent timezone handling
      });
    };

    return `Please select a date between ${formatDate(min)} and ${formatDate(max)}`;
  },
});

export default {
  name: 'activate',
  mixins: [recaptchaMix],
  components: {
    Spinner,
    ErrorIcon,
    Recaptcha,
    TheMask,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    teamType: {
      type: String,
      default: null,
    },
    referralCode: {
      type: String,
      default: null,
    },
    referralId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formStarted: false,
      teamLevel: null,
      availableLevels: [
        'Booster club',
        'Club',
        'College',
        'High school',
        'Middle school / Junior high',
        'RTC',
        'Town Rec Program',
      ],
      timeZone: null,
      timeZones: [['America/Los_Angeles', 'Pacific'], ['America/Denver', 'Mountain (most areas)'], ['America/Chicago', 'Central (most areas)'], ['America/New_York', 'Eastern (most areas)'], ['America/Detroit', 'Eastern - MI (most areas)'], ['America/Kentucky/Louisville', 'Eastern - KY (Louisville area)'], ['America/Kentucky/Monticello', 'Eastern - KY (Wayne)'], ['America/Indiana/Indianapolis', 'Eastern - IN (most areas)'], ['America/Indiana/Vincennes', 'Eastern - IN (Da, Du, K, Mn)'], ['America/Indiana/Winamac', 'Eastern - IN (Pulaski)'], ['America/Indiana/Marengo', 'Eastern - IN (Crawford)'], ['America/Indiana/Petersburg', 'Eastern - IN (Pike)'], ['America/Indiana/Vevay', 'Eastern - IN (Switzerland)'], ['America/Indiana/Tell_City', 'Central - IN (Perry)'], ['America/Indiana/Knox', 'Central - IN (Starke)'], ['America/Menominee', 'Central - MI (Wisconsin border)'], ['America/North_Dakota/Center', 'Central - ND (Oliver)'], ['America/North_Dakota/New_Salem', 'Central - ND (Morton rural)'], ['America/North_Dakota/Beulah', 'Central - ND (Mercer)'], ['America/Boise', 'Mountain - ID (south); OR (east)'], ['America/Phoenix', 'MST - Arizona (except Navajo)'], ['America/Anchorage', 'Alaska (most areas)'], ['America/Juneau', 'Alaska - Juneau area'], ['America/Sitka', 'Alaska - Sitka area'], ['America/Metlakatla', 'Alaska - Annette Island'], ['America/Yakutat', 'Alaska - Yakutat'], ['America/Nome', 'Alaska (west)'], ['America/Adak', 'Aleutian Islands'], ['Pacific/Honolulu', 'Hawaii']],
      clubEntityTypes: [
        {
          label: 'Limited Liability Company (LLC)',
          subtext: 'Single-member or multi-member LLC',
        },
        {
          label: 'Non-profit',
          subtext: '501c3 or state level non-profit entity with a Federal EIN',
        },
        {
          label: 'C-Corporation',
          subtext: 'Independent legal entity',
        },
        {
          label: 'Partnership',
          subtext: 'Formal partnership with a Federal EIN',
        },
        {
          label: 'Sole Proprietorship',
          subtext: 'You own and operate under your own SSN. If you have no formal business structure, you are a sole proprietor.',
        },
        {
          label: 'Other',
          subtext: 'A different type of entity not listed above',
        },
      ],
      usStates: [
        { abbr: 'AL', name: 'Alabama' },
        { abbr: 'AK', name: 'Alaska' },
        { abbr: 'AZ', name: 'Arizona' },
        { abbr: 'AR', name: 'Arkansas' },
        { abbr: 'CA', name: 'California' },
        { abbr: 'CO', name: 'Colorado' },
        { abbr: 'CT', name: 'Connecticut' },
        { abbr: 'DC', name: 'District of Columbia' },
        { abbr: 'DE', name: 'Delaware' },
        { abbr: 'FL', name: 'Florida' },
        { abbr: 'GA', name: 'Georgia' },
        { abbr: 'HI', name: 'Hawaii' },
        { abbr: 'ID', name: 'Idaho' },
        { abbr: 'IL', name: 'Illinois' },
        { abbr: 'IN', name: 'Indiana' },
        { abbr: 'IA', name: 'Iowa' },
        { abbr: 'KS', name: 'Kansas' },
        { abbr: 'KY', name: 'Kentucky' },
        { abbr: 'LA', name: 'Louisiana' },
        { abbr: 'ME', name: 'Maine' },
        { abbr: 'MD', name: 'Maryland' },
        { abbr: 'MA', name: 'Massachusetts' },
        { abbr: 'MI', name: 'Michigan' },
        { abbr: 'MN', name: 'Minnesota' },
        { abbr: 'MS', name: 'Mississippi' },
        { abbr: 'MO', name: 'Missouri' },
        { abbr: 'MT', name: 'Montana' },
        { abbr: 'NE', name: 'Nebraska' },
        { abbr: 'NV', name: 'Nevada' },
        { abbr: 'NH', name: 'New Hampshire' },
        { abbr: 'NJ', name: 'New Jersey' },
        { abbr: 'NM', name: 'New Mexico' },
        { abbr: 'NY', name: 'New York' },
        { abbr: 'NC', name: 'North Carolina' },
        { abbr: 'ND', name: 'North Dakota' },
        { abbr: 'OH', name: 'Ohio' },
        { abbr: 'OK', name: 'Oklahoma' },
        { abbr: 'OR', name: 'Oregon' },
        { abbr: 'PA', name: 'Pennsylvania' },
        { abbr: 'RI', name: 'Rhode Island' },
        { abbr: 'SC', name: 'South Carolina' },
        { abbr: 'SD', name: 'South Dakota' },
        { abbr: 'TN', name: 'Tennessee' },
        { abbr: 'TX', name: 'Texas' },
        { abbr: 'UT', name: 'Utah' },
        { abbr: 'VT', name: 'Vermont' },
        { abbr: 'VA', name: 'Virginia' },
        { abbr: 'WA', name: 'Washington' },
        { abbr: 'WV', name: 'West Virginia' },
        { abbr: 'WI', name: 'Wisconsin' },
        { abbr: 'WY', name: 'Wyoming' },
        { abbr: 'AS', name: 'American Samoa' },
        { abbr: 'GU', name: 'Guam' },
        { abbr: 'MP', name: 'Northern Mariana Islands' },
        { abbr: 'PR', name: 'Puerto Rico' },
        { abbr: 'VI', name: 'U.S. Virgin Islands' },
      ],
      websiteInfo: false,
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      teamName: '',
      website: '',
      state: '',
      country: 'US',
      startDate: '',
      creatingLead: false,
      hearAbout: '',
      anythingElse: '',
      selectedOutcome: '',
      customOutcome: '',
      outcomeOptions: [
        { value: 'admin-time', label: 'Spend less time on admin tasks' },
        { value: 'revenue', label: 'Increase revenue or number of wrestlers' },
        { value: 'attendance', label: 'Improve wrestler attendance' },
        { value: 'peace-of-mind', label: 'Have enough peace of mind to take a vacation' },
        { value: 'grants', label: 'Use WIQ data to apply for grants' },
        { value: 'staff', label: 'Have my staff fully trained, communicating, and operating through WIQ' },
      ],
      adminHours: 0,
      additionalAdmins: [],
      painPoints: [
        { id: 1, text: 'Handling registrations. E.g. collecting registration info, signing liability forms, and payments.', selected: false },
        { id: 2, text: 'Communicating with the team', selected: false },
        { id: 3, text: 'Handling insurance or USAW/AAU card requirements', selected: false },
        { id: 4, text: 'Tracking wrestler attendance', selected: false },
        { id: 5, text: 'Planning practice', selected: false },
        { id: 6, text: 'Recording and reviewing match videos', selected: false },
        { id: 7, text: 'Coordinating private lessons', selected: false },
      ],

      showParentBlockerChoices: true,
      showParentBlocker: false,
      showActivationForm: false,

      errorMessage: '',
      error: false,
      clubEntityType: '',
      clubEntityDropdownOpen: false,
    };
  },
  mounted() {
    this.teamLevel = this.teamType;
  },
  computed: {
    hsPrice() {
      if (this.isWlag) {
        return '$540 /year';
      }

      return '$600 /year';
    },
    isWlag() {
      return this.referralCode === 'wlag';
    },
    isBooster() {
      return this.teamLevel === 'Booster club';
    },
    isClub() {
      return this.teamLevel === 'Club';
    },
    isCollege() {
      return this.teamLevel === 'College';
    },
    isHsCollegeOrJhs() {
      return ['College', 'High school', 'Middle school / Junior high', 'High school and Booster club', 'Town Rec Program'].includes(this.teamLevel);
    },
    isHs() {
      return this.teamLevel === 'High school';
    },
    isRTC() {
      return this.teamLevel === 'RTC';
    },
    isJhs() {
      return this.teamLevel === 'Middle school / Junior high';
    },
    isRec() {
      return this.teamLevel === 'Town Rec Program';
    },
    minStartDate() {
      // Get today's date in user's timezone
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return today.toISOString().split('T')[0];
    },
    maxStartDate() {
      // 10 months from today
      const tenMonthsFromNow = new Date();
      tenMonthsFromNow.setMonth(tenMonthsFromNow.getMonth() + 10);
      return tenMonthsFromNow.toISOString().split('T')[0];
    },
    stateLabel() {
      if (this.country === 'CA') {
        return 'Province';
      } if (this.country === 'US') {
        return 'State';
      }
      return 'State / Province';
    },
    selectedClubEntityType() {
      return this.clubEntityTypes.find((type) => type.label === this.clubEntityType);
    },
    hasSelectedTeamLevel() {
      return this.teamLevel !== null && this.teamLevel !== '';
    },
    selectedPainPoints() {
      return this.painPoints.filter((point) => point.selected);
    },
  },
  watch: {
    country(newVal, oldVal) {
      // Clear state when switching from US to another country
      if (oldVal === 'US' && newVal !== 'US') {
        this.state = '';
      }
    },
  },
  methods: {
    // First focus into the signup form is the top of the ad funnel; the
    // matching `Lead` fires on /activate/config after the lead is created.
    // Our Meta pixel (shared/_meta_pixel.html.erb) only renders in production
    // behind the advertising opt out, so fbq is often absent — guard, don't
    // assume. Fires once per page load so starts minus leads reads as
    // drop-offs in Ads Manager.
    trackFormStart() {
      if (this.formStarted) return;
      this.formStarted = true;
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'FormStart', { form_name: 'activate' });
      }
    },
    handlePainPointSelection(point) {
      // Vue's v-model will handle the checkbox state change
      // This method is just for any additional logic if needed
    },
    enableParentBlocker() {
      this.showParentBlockerChoices = false;
      this.showParentBlocker = true;
      this.showActivationForm = false;
    },
    enbaleActivateForm() {
      this.showParentBlockerChoices = false;
      this.showParentBlocker = false;
      this.showActivationForm = true;
    },
    inputClasses(error) {
      const normalClasses = 'py-3 px-4 shadow-sm block w-full border-gray-300 rounded-md sm:text-sm';
      if (!error) {
        return `${normalClasses} focus:ring-wiq-green focus:border-wiq-green border-gray-300`;
      }

      return `border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:ring-red ${normalClasses}`;
    },
    selectClubEntityType(type) {
      this.clubEntityType = type.label;
      this.clubEntityDropdownOpen = false;
    },
    addAdmin() {
      this.additionalAdmins.push({
        first_name: '',
        last_name: '',
        email: '',
      });
    },
    removeAdmin(index) {
      this.additionalAdmins.splice(index, 1);
    },
    async createLead() {
      if (this.creatingLead) {
        return;
      }

      // Validate that exactly 3 pain points are selected
      if (this.selectedPainPoints.length > 3) {
        this.errorMessage = 'Please select 3 or less pain points before continuing.';
        this.error = true;
        return;
      }

      this.creatingLead = true;
      this.errorMessage = '';
      this.error = false;

      const params = {
        'g-recaptcha-response-data': await this.$refs.recaptcha.getCaptchaResponse(),
        lead: {
          name: this.firstName,
          last_name: this.lastName,
          email: this.email,
          phone_number: this.phone,
          team_name: this.teamName,
          website: this.website,
          state: this.state,
          country: this.country,
          level: this.teamLevel,
          time_zone: this.timeZone,
          entity_type: this.clubEntityType,
          preferred_slug: this.teamName.replace(/\s+/g, ''),
          website_interest: this.websiteInfo,
          season_start_at: this.startDate,
          referral_partner_id: this.referralId,
          hear_about_us: this.hearAbout,
          anything_else: this.anythingElse,
          lead_type: 'free_trial',
          outcome_goal: {
            selected_outcome: this.selectedOutcome,
            custom_outcome: this.customOutcome,
          },
          estimated_weekly_admin_hours: this.adminHours,
          pain_points: this.selectedPainPoints.map((point) => point.text),
          additional_admins: this.additionalAdmins,
        },
      };
      const vm = this;
      axios.post('/v2/leads', params)
        .then((response) => {
          this.creatingLead = false;
          window.location.assign(`/activate/config?email=${encodeURIComponent(this.email)}`);
        })
        .catch((error) => {
          vm.creatingLead = false;
          vm.creatingSession = false;
          vm.errorMessage = `Error, please try again later or contact support@wrestlingiq.com ${error.toString()}`;
          vm.error = true;
          if (vm.isRecaptchaError(error)) {
            vm.$refs.recaptcha.handleCaptchaFailed();
            vm.errorMessage = 'Recaptcha failed. Please solve and try again.';
          }
        });
    },
  },
};
</script>
